const ROUTING_NUMBER_PATTERN = /^\d{9}$/

const CHECKSUM_WEIGHTS = [3, 7, 1, 3, 7, 1, 3, 7, 1]

/** Nine digits plus the ABA checksum — mirrors para-node's `IsRoutingNumber` validator. */
export const isValidRoutingNumber = (value: string): boolean => {
  if (!ROUTING_NUMBER_PATTERN.test(value)) {
    return false
  }

  const checksum = value.split('').reduce((sum, digit, index) => {
    return sum + Number(digit) * CHECKSUM_WEIGHTS[index]
  }, 0)

  return checksum % 10 === 0
}
